import _regeneratorRuntime from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import ChatManagerInstance from "./Chat/ChatManager";
import BroadcastThreadManagerInstance from "./Chat/BroadcastThreadManager";

var _init = function _init(restApiURL, partnerName, logLevel) {
  ChatManagerInstance.init(restApiURL, partnerName, logLevel);
};

var _threadInit = function _threadInit(accessToken, threadName) {
  BroadcastThreadManagerInstance.init(accessToken, threadName);
};

var _getUserDetails = function _getUserDetails() {
  return BroadcastThreadManagerInstance.getUserDetails();
};

var _loadAroundMessages = function _loadAroundMessages(timestamp, beforeSize, afterSize) {
  return BroadcastThreadManagerInstance.loadAroundMessages(timestamp, beforeSize, afterSize);
};

var _threadUpdateLastReadTimestamp = function _threadUpdateLastReadTimestamp(lastReadTimestamp) {
  return BroadcastThreadManagerInstance.updateLastReadTimestamp(lastReadTimestamp);
};

var _toggleDisabledThread = function _toggleDisabledThread(disabled) {
  return BroadcastThreadManagerInstance.toggleDisabledThread(disabled);
};

var _checkRoomOnline = function _checkRoomOnline(roomName, accessToken, checkRoomOnlineHandler) {
  ChatManagerInstance.checkRoomOnline(roomName, accessToken, checkRoomOnlineHandler);
};

var _getChatSession = function _getChatSession(sessionId) {
  return ChatManagerInstance.getChatSession(sessionId);
};

var _getConversationSession = function _getConversationSession(sessionId) {
  return ChatManagerInstance.getConversationSession(sessionId);
};

var _getGlobalPresenceSession = function _getGlobalPresenceSession(sessionId) {
  return ChatManagerInstance.getGlobalPresenceSession(sessionId);
};

var _createRoom = function _createRoom(sessionId, roomStatus, custom, createRoomHandler) {
  _getChatSession(sessionId).createRoom(roomStatus, custom, createRoomHandler);
};

var _sessionCheckRoomOnline = function _sessionCheckRoomOnline(sessionId, checkRoomOnlineHandler) {
  _getChatSession(sessionId).checkRoomOnline(checkRoomOnlineHandler);
};

var _joinRoom = function _joinRoom(sessionId, joinRoomHandler) {
  _getChatSession(sessionId).joinRoom(joinRoomHandler);
};

var _createAndJoinRoom = function _createAndJoinRoom(sessionId, roomStatus, custom, createAndJoinRoomHandler) {
  _getChatSession(sessionId).createAndJoinRoom(roomStatus, custom, createAndJoinRoomHandler);
};

var _addUserToPresenceNode = function _addUserToPresenceNode(sessionId, addToPresenceNodeHandler) {
  _getChatSession(sessionId).addToPresenceNode(addToPresenceNodeHandler);
};

var _updateRoom = function _updateRoom(sessionId, roomStatus, custom, updateRoomHandler) {
  _getChatSession(sessionId).updateRoom(roomStatus, custom, updateRoomHandler);
};

var _closeRoom = function _closeRoom(sessionId, closeRoomHandler) {
  _getChatSession(sessionId).closeRoom(closeRoomHandler);
};

var _leaveRoom = function _leaveRoom(sessionId, leaveRoomHandler) {
  _getChatSession(sessionId).leaveRoom(leaveRoomHandler);
};

var _writeMessage = function _writeMessage(sessionId, message) {
  _getChatSession(sessionId).writeMessage(message);
};

var _writeCustomMessage = function _writeCustomMessage(sessionId, message) {
  _getChatSession(sessionId).writeCustomMessage(message);
};

var _writeConversationCustomMessage = function _writeConversationCustomMessage(sessionId, details, message) {
  _getConversationSession(sessionId).writeCustomMessage(details, message);
};

var _writeConversationMessage = function _writeConversationMessage(sessionId, message) {
  _getConversationSession(sessionId).writeMessage(message);
};

var _editConversationMessage = function _editConversationMessage(sessionId, messageId, message, callback) {
  _getConversationSession(sessionId).editMessage(messageId, message, callback);
};

var _deleteConversationMessage = function _deleteConversationMessage(sessionId, messageId, callback) {
  _getConversationSession(sessionId).deleteMessage(messageId, callback);
};

var _updateCustomField = function _updateCustomField(sessionId, key, value) {
  _getConversationSession(sessionId).updateCustomField(key, value);
};

var _writeResourceMessage = function _writeResourceMessage(sessionId, resource, message, writeResourceMessageHandler, type) {
  _getConversationSession(sessionId).writeResourceMessage(resource, message, writeResourceMessageHandler, type);
};

var _getResourceDetails = function _getResourceDetails(sessionId, resource, getResourceDetailsHandler, abortSignal) {
  _getConversationSession(sessionId).getResourceDetails(resource, getResourceDetailsHandler, abortSignal);
};

var _createResourceEntry = function _createResourceEntry(sessionId, audioFile, formatValue, createResourceEntryHandler) {
  _getConversationSession(sessionId).createResourceEntry(audioFile, formatValue, createResourceEntryHandler);
};

var _updateLastReadTimestamp = function _updateLastReadTimestamp(sessionId, timestamp, updateLastReadTimestampHandler) {
  _getConversationSession(sessionId).updateLastReadTimestamp(timestamp, updateLastReadTimestampHandler);
};

var _leaveConversation = function _leaveConversation(sessionId) {
  _getConversationSession(sessionId).leaveConversation();
};

var _getAroundMessages = function _getAroundMessages(sessionId, timestamp, beforeSize, afterSize, readAroundMessagesHandler, abortSignal) {
  _getConversationSession(sessionId).getAroundMessages(timestamp, beforeSize, afterSize, readAroundMessagesHandler, abortSignal);
};

var _getNextMessages = function _getNextMessages(sessionId, timestamp, page, size, readNextMessagesHandler) {
  _getConversationSession(sessionId).getNextMessages(timestamp, page, size, readNextMessagesHandler);
};

var _getPreviousMessages = function _getPreviousMessages(sessionId, timestamp, page, size, readPreviousMessagesHandler) {
  _getConversationSession(sessionId).getPreviousMessages(timestamp, page, size, readPreviousMessagesHandler);
};

var _setConversationListener = function _setConversationListener(sessionId, conversationListener) {
  var converstionSession = _getConversationSession(sessionId);

  if (converstionSession) {
    converstionSession.setConversationListener(conversationListener);
  }
};

var _requestFirebaseAccess = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sessionId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _getConversationSession(sessionId).requestFirebaseAccess();

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function _requestFirebaseAccess(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _setRoomStateListener = function _setRoomStateListener(sessionId, roomStateListener) {
  _getChatSession(sessionId).setRoomStateListener(roomStateListener);
};

var _setRoomRosterListener = function _setRoomRosterListener(sessionId, roomRosterListener) {
  _getChatSession(sessionId).setRoomRosterListener(roomRosterListener);
};

var _setRoomMessagesListener = function _setRoomMessagesListener(sessionId, roomMessagesListener) {
  _getChatSession(sessionId).setRoomMessagesListener(roomMessagesListener);
};

var _setRoomUsersCountListener = function _setRoomUsersCountListener(sessionId, roomUsersCountListener) {
  _getChatSession(sessionId).setRoomUsersCountListener(roomUsersCountListener);
};

var _setConnectionListener = function _setConnectionListener(sessionId, connectionListener) {
  _getChatSession(sessionId).setConnectionListener(connectionListener);
};

var _addToGlobalPresence = function _addToGlobalPresence(sessionId, addToGlobalPresenceHandler) {
  _getGlobalPresenceSession(sessionId).addToGlobalPresence(addToGlobalPresenceHandler);
};

var _addToGlobalPresenceWithLocation = function _addToGlobalPresenceWithLocation(sessionId, addToGlobalPresenceHandler, location) {
  _getGlobalPresenceSession(sessionId).addToGlobalPresenceWithLocation(location, addToGlobalPresenceHandler);
};

var _removeFromGlobalPresence = function _removeFromGlobalPresence(sessionId, removeFromGlobalPresenceHandler) {
  _getGlobalPresenceSession(sessionId).removeFromGlobalPresence(removeFromGlobalPresenceHandler);
};

var _removeFromGlobalPresenceWithLocation = function _removeFromGlobalPresenceWithLocation(sessionId, removeFromGlobalPresenceHandler, location) {
  _getGlobalPresenceSession(sessionId).removeFromGlobalPresenceWithLocation(location, removeFromGlobalPresenceHandler);
};

var _setGlobalRosterListener = function _setGlobalRosterListener(sessionId, globalRosterListener) {
  _getGlobalPresenceSession(sessionId).setGlobalRosterListener(globalRosterListener);
};

var _setGlobalRosterListenerWithLocation = function _setGlobalRosterListenerWithLocation(sessionId, globalRosterListener, location) {
  _getGlobalPresenceSession(sessionId).setGlobalRosterListenerWithLocation(location, globalRosterListener);
};

var _setGlobalEventsListener = function _setGlobalEventsListener(sessionId, globalEventsListener) {
  _getGlobalPresenceSession(sessionId).setGlobalEventsListener(globalEventsListener);
};

var _detachGlobalRosterListener = function _detachGlobalRosterListener(sessionId) {
  _getGlobalPresenceSession(sessionId).detachGlobalRosterListener();
};

var _detachGlobalRosterListenerWithLocation = function _detachGlobalRosterListenerWithLocation(sessionId, location) {
  _getGlobalPresenceSession(sessionId).detachGlobalRosterListenerWithLocation(location);
};

var _detachGlobalEventsListener = function _detachGlobalEventsListener(sessionId) {
  _getGlobalPresenceSession(sessionId).detachGlobalEventsListener();
};

var _detachSystemLastEventListener = function _detachSystemLastEventListener(sessionId) {
  _getGlobalPresenceSession(sessionId).detachSystemLastEventListener();
};

var _detachSystemLastEventListenerWithLocation = function _detachSystemLastEventListenerWithLocation(sessionId, location) {
  _getGlobalPresenceSession(sessionId).detachSystemLastEventListenerWithLocation(location);
};

var _setSystemLastEventListner = function _setSystemLastEventListner(sessionId, systemLastEventListener) {
  _getGlobalPresenceSession(sessionId).setSystemLastEventListner(systemLastEventListener);
};

var _setSystemLastEventListenerWithLocation = function _setSystemLastEventListenerWithLocation(sessionId, location, systemLastEventListener) {
  _getGlobalPresenceSession(sessionId).setSystemLastEventListnerWithLocation(location, systemLastEventListener);
};

var _getNumberOfUnreadThreads = function _getNumberOfUnreadThreads(sessionId, getNumberOfUnreadThreadsHandler) {
  _getGlobalPresenceSession(sessionId).getNumberOfUnreadThreads(getNumberOfUnreadThreadsHandler);
};

var _getNumberOfUnreadItems = function _getNumberOfUnreadItems(sessionId, getNumberOfUnreadItemsHandler) {
  _getGlobalPresenceSession(sessionId).getNumberOfUnreadItems(getNumberOfUnreadItemsHandler);
};

var _checkForCensoredWords = function _checkForCensoredWords(sessionId, message, checkForCensoredWordsHandler) {
  _getGlobalPresenceSession(sessionId).checkForCensoredWords(message, checkForCensoredWordsHandler);
};

var createConversationSessionHandler = function createConversationSessionHandler(conversationSessionParam, error, clientCreateConversationSessionHandler) {
  var conversationSessionWrapper;

  if (!error) {
    conversationSessionWrapper = {
      id: conversationSessionParam.id,
      userName: conversationSessionParam.userName,
      conversationName: conversationSessionParam.conversationName,
      writeMessage: function writeMessage(message) {
        _writeConversationMessage(conversationSessionParam.id, message);
      },
      editMessage: function editMessage(messageId, message, callback) {
        _editConversationMessage(conversationSessionParam.id, messageId, message, callback);
      },
      deleteMessage: function deleteMessage(messageId, callback) {
        _deleteConversationMessage(conversationSessionParam.id, messageId, callback);
      },
      writeConversationCustomMessage: function writeConversationCustomMessage(details, message) {
        _writeConversationCustomMessage(conversationSessionParam.id, details, message);
      },
      updateCustomField: function updateCustomField(key, value) {
        _updateCustomField(conversationSessionParam.id, key, value);
      },
      writeResourceMessage: function writeResourceMessage(resource, message, writeResourceMessageHandler, type) {
        _writeResourceMessage(conversationSessionParam.id, resource, message, writeResourceMessageHandler, type);
      },
      createResourceEntry: function createResourceEntry(audioFile, formatValue, createResourceEntryHandler) {
        _createResourceEntry(conversationSessionParam.id, audioFile, formatValue, createResourceEntryHandler);
      },
      getResourceDetails: function getResourceDetails(resource, getResourceDetailsHandler, abortSignal) {
        _getResourceDetails(conversationSessionParam.id, resource, getResourceDetailsHandler, abortSignal);
      },
      updateLastReadTimestamp: function updateLastReadTimestamp(timestamp, updateLastReadTimestampHandler) {
        _updateLastReadTimestamp(conversationSessionParam.id, timestamp, updateLastReadTimestampHandler);
      },
      leaveConversation: function leaveConversation() {
        _leaveConversation(conversationSessionParam.id);
      },
      getAroundMessages: function getAroundMessages(timestamp, beforeSize, afterSize, readAroundMessagesHandler, abortSignal) {
        _getAroundMessages(conversationSessionParam.id, timestamp, beforeSize, afterSize, readAroundMessagesHandler, abortSignal);
      },
      getNextMessages: function getNextMessages(timestamp, page, size, readNextMessagesHandler) {
        _getNextMessages(conversationSessionParam.id, timestamp, page, size, readNextMessagesHandler);
      },
      getPreviousMessages: function getPreviousMessages(timestamp, page, size, readPreviousMessagesHandler) {
        _getPreviousMessages(conversationSessionParam.id, timestamp, page, size, readPreviousMessagesHandler);
      },
      setConversationListener: function setConversationListener(conversationListener) {
        _setConversationListener(conversationSessionParam.id, conversationListener);
      },
      requestRealTimeDatabaseAccess: function () {
        var _requestRealTimeDatabaseAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _requestFirebaseAccess(conversationSessionParam.id);

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function requestRealTimeDatabaseAccess() {
          return _requestRealTimeDatabaseAccess.apply(this, arguments);
        }

        return requestRealTimeDatabaseAccess;
      }()
    };
  }

  if (clientCreateConversationSessionHandler !== void 0) {
    clientCreateConversationSessionHandler(conversationSessionWrapper, error);
  }
};

var createGlobalPresenceSessionHandler = function createGlobalPresenceSessionHandler(globalPresenceSessionParam, error, clientCreateGlobalPresenceSessionHandler) {
  var globalPresenceSessionWrapper;

  if (!error) {
    globalPresenceSessionWrapper = {
      id: globalPresenceSessionParam.id,
      userName: globalPresenceSessionParam.userName,
      addToGlobalPresence: function addToGlobalPresence(addToGlobalPresenceHandler) {
        _addToGlobalPresence(globalPresenceSessionParam.id, addToGlobalPresenceHandler);
      },
      addToGlobalPresenceWithLocation: function addToGlobalPresenceWithLocation(location, addToGlobalPresenceHandler) {
        _addToGlobalPresenceWithLocation(globalPresenceSessionParam.id, addToGlobalPresenceHandler, location);
      },
      removeFromGlobalPresence: function removeFromGlobalPresence(removeFromGlobalPresenceHandler) {
        _removeFromGlobalPresence(globalPresenceSessionParam.id, removeFromGlobalPresenceHandler);
      },
      removeFromGlobalPresenceWithLocation: function removeFromGlobalPresenceWithLocation(location, removeFromGlobalPresenceHandler) {
        _removeFromGlobalPresenceWithLocation(globalPresenceSessionParam.id, removeFromGlobalPresenceHandler, location);
      },
      setGlobalRosterListener: function setGlobalRosterListener(globalRosterListener) {
        _setGlobalRosterListener(globalPresenceSessionParam.id, globalRosterListener);
      },
      setGlobalRosterListenerWithLocation: function setGlobalRosterListenerWithLocation(location, globalRosterListener) {
        _setGlobalRosterListenerWithLocation(globalPresenceSessionParam.id, globalRosterListener, location);
      },
      setGlobalEventsListener: function setGlobalEventsListener(globalEventsListener) {
        _setGlobalEventsListener(globalPresenceSessionParam.id, globalEventsListener);
      },
      detachGlobalRosterListener: function detachGlobalRosterListener() {
        _detachGlobalRosterListener(globalPresenceSessionParam.id);
      },
      detachGlobalRosterListenerWithLocation: function detachGlobalRosterListenerWithLocation(location) {
        _detachGlobalRosterListenerWithLocation(globalPresenceSessionParam.id, location);
      },
      detachGlobalEventsListener: function detachGlobalEventsListener() {
        _detachGlobalEventsListener(globalPresenceSessionParam.id);
      },
      detachSystemLastEventListener: function detachSystemLastEventListener() {
        _detachSystemLastEventListener(globalPresenceSessionParam.id);
      },
      detachSystemLastEventListenerWithLocation: function detachSystemLastEventListenerWithLocation(location) {
        _detachSystemLastEventListenerWithLocation(globalPresenceSessionParam.id, location);
      },
      setSystemLastEventListner: function setSystemLastEventListner(systemLastEventListener) {
        _setSystemLastEventListner(globalPresenceSessionParam.id, systemLastEventListener);
      },
      setSystemLastEventListenerWithLocation: function setSystemLastEventListenerWithLocation(location, systemLastEventListener) {
        _setSystemLastEventListenerWithLocation(globalPresenceSessionParam.id, location, systemLastEventListener);
      },
      getNumberOfUnreadThreads: function getNumberOfUnreadThreads(getNumberOfUnreadThreadsHandler) {
        _getNumberOfUnreadThreads(globalPresenceSessionParam.id, getNumberOfUnreadThreadsHandler);
      },
      getNumberOfUnreadItems: function getNumberOfUnreadItems(getNumberOfUnreadItemsHandler) {
        _getNumberOfUnreadItems(globalPresenceSessionParam.id, getNumberOfUnreadItemsHandler);
      },
      checkForCensoredWords: function checkForCensoredWords(message, checkForCensoredWordsHandler) {
        _checkForCensoredWords(globalPresenceSessionParam.id, message, checkForCensoredWordsHandler);
      }
    };
  }

  if (clientCreateGlobalPresenceSessionHandler !== void 0) {
    clientCreateGlobalPresenceSessionHandler(globalPresenceSessionWrapper, error);
  }
};

var createSessionHandler = function createSessionHandler(chatSessionParam, error, clientCreateSessionHandler) {
  var chatSessionWrapper;

  if (!error) {
    chatSessionWrapper = {
      id: chatSessionParam.id,
      userName: chatSessionParam.userName,
      roomName: chatSessionParam.roomName,
      createAndJoinRoom: function createAndJoinRoom(roomStatus, custom, createAndJoinRoomHandler) {
        _createAndJoinRoom(chatSessionParam.id, roomStatus, custom, createAndJoinRoomHandler);
      },
      addUserToPresenceNode: function addUserToPresenceNode(addUserToPresenceNodeHandler) {
        _addUserToPresenceNode(chatSessionParam.id, addUserToPresenceNodeHandler);
      },
      createRoom: function createRoom(roomStatus, custom, createRoomHandler) {
        _createRoom(chatSessionParam.id, roomStatus, custom, createRoomHandler);
      },
      checkRoomOnline: function checkRoomOnline(checkRoomOnlineHandler) {
        _sessionCheckRoomOnline(chatSessionParam.id, checkRoomOnlineHandler);
      },
      updateRoom: function updateRoom(roomStatus, custom, updateRoomHandler) {
        _updateRoom(chatSessionParam.id, roomStatus, custom, updateRoomHandler);
      },
      joinRoom: function joinRoom(joinRoomHandler) {
        _joinRoom(chatSessionParam.id, joinRoomHandler);
      },
      closeRoom: function closeRoom(closeRoomHandler) {
        _closeRoom(chatSessionParam.id, closeRoomHandler);
      },
      leaveRoom: function leaveRoom(leaveRoomHandler) {
        _leaveRoom(chatSessionParam.id, leaveRoomHandler);
      },
      writeMessage: function writeMessage(message) {
        _writeMessage(chatSessionParam.id, message);
      },
      writeCustomMessage: function writeCustomMessage(message) {
        _writeCustomMessage(chatSessionParam.id, message);
      },
      setRoomStateListener: function setRoomStateListener(roomStateListener) {
        _setRoomStateListener(chatSessionParam.id, roomStateListener);
      },
      setRoomRosterListener: function setRoomRosterListener(roomRosterListener) {
        _setRoomRosterListener(chatSessionParam.id, roomRosterListener);
      },
      setRoomMessagesListener: function setRoomMessagesListener(roomMessagesListener) {
        _setRoomMessagesListener(chatSessionParam.id, roomMessagesListener);
      },
      setRoomUsersCountListener: function setRoomUsersCountListener(usersCountListener) {
        _setRoomUsersCountListener(chatSessionParam.id, usersCountListener);
      },
      setConnectionListener: function setConnectionListener(connectionListener) {
        _setConnectionListener(chatSessionParam.id, connectionListener);
      }
    };
  }

  if (clientCreateSessionHandler !== void 0) {
    clientCreateSessionHandler(chatSessionWrapper, error);
  }
};

var createSessionHandlerAsync = function createSessionHandlerAsync(chatSessionParam, error) {
  var chatSessionWrapper;

  if (!error) {
    chatSessionWrapper = {
      id: chatSessionParam.id,
      userName: chatSessionParam.userName,
      roomName: chatSessionParam.roomName,
      createAndJoinRoom: function createAndJoinRoom(roomStatus, custom, createAndJoinRoomHandler) {
        _createAndJoinRoom(chatSessionParam.id, roomStatus, custom, createAndJoinRoomHandler);
      },
      addUserToPresenceNode: function addUserToPresenceNode(addUserToPresenceNodeHandler) {
        _addUserToPresenceNode(chatSessionParam.id, addUserToPresenceNodeHandler);
      },
      createRoom: function createRoom(roomStatus, custom, createRoomHandler) {
        _createRoom(chatSessionParam.id, roomStatus, custom, createRoomHandler);
      },
      checkRoomOnline: function checkRoomOnline(checkRoomOnlineHandler) {
        _sessionCheckRoomOnline(chatSessionParam.id, checkRoomOnlineHandler);
      },
      updateRoom: function updateRoom(roomStatus, custom, updateRoomHandler) {
        _updateRoom(chatSessionParam.id, roomStatus, custom, updateRoomHandler);
      },
      joinRoom: function joinRoom(joinRoomHandler) {
        _joinRoom(chatSessionParam.id, joinRoomHandler);
      },
      closeRoom: function closeRoom(closeRoomHandler) {
        _closeRoom(chatSessionParam.id, closeRoomHandler);
      },
      leaveRoom: function leaveRoom(leaveRoomHandler) {
        _leaveRoom(chatSessionParam.id, leaveRoomHandler);
      },
      writeMessage: function writeMessage(message) {
        _writeMessage(chatSessionParam.id, message);
      },
      writeCustomMessage: function writeCustomMessage(message) {
        _writeCustomMessage(chatSessionParam.id, message);
      },
      setRoomStateListener: function setRoomStateListener(roomStateListener) {
        _setRoomStateListener(chatSessionParam.id, roomStateListener);
      },
      setRoomRosterListener: function setRoomRosterListener(roomRosterListener) {
        _setRoomRosterListener(chatSessionParam.id, roomRosterListener);
      },
      setRoomMessagesListener: function setRoomMessagesListener(roomMessagesListener) {
        _setRoomMessagesListener(chatSessionParam.id, roomMessagesListener);
      },
      setRoomUsersCountListener: function setRoomUsersCountListener(usersCountListener) {
        _setRoomUsersCountListener(chatSessionParam.id, usersCountListener);
      },
      setConnectionListener: function setConnectionListener(connectionListener) {
        _setConnectionListener(chatSessionParam.id, connectionListener);
      }
    };
  }

  return {
    chatSession: chatSessionWrapper,
    error: error
  };
};

var _createGlobalPresenceSession = function _createGlobalPresenceSession(userName, accessToken, clientCreateGlobalPresenceSessionHandlerParam) {
  ChatManagerInstance.createGlobalPresenceSession(userName, accessToken, function (globalPresenceSessionParam, error) {
    createGlobalPresenceSessionHandler(globalPresenceSessionParam, error, clientCreateGlobalPresenceSessionHandlerParam);
  });
};

var _createSession = function _createSession(roomName, userName, accessToken, clientCreateSessionHandlerParam) {
  ChatManagerInstance.createSession(roomName, userName, accessToken, function (chatSessionParam, error) {
    createSessionHandler(chatSessionParam, error, clientCreateSessionHandlerParam);
  });
};

var _createSessionAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(roomName, userName, accessToken, firebaseCredentials) {
    var _yield$ChatManagerIns, error, data;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return ChatManagerInstance.createSessionAsync(roomName, userName, accessToken, firebaseCredentials);

          case 2:
            _yield$ChatManagerIns = _context3.sent;
            error = _yield$ChatManagerIns.error;
            data = _yield$ChatManagerIns.data;
            return _context3.abrupt("return", createSessionHandlerAsync(data, error));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function _createSessionAsync(_x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var _createConversationSession = function _createConversationSession(conversationName, userName, accessToken, clientCreateConversationSessionHandlerParam) {
  ChatManagerInstance.createConversationSession(conversationName, userName, accessToken, function (conversationSessionParam, error) {
    createConversationSessionHandler(conversationSessionParam, error, clientCreateConversationSessionHandlerParam);
  });
};

var _createConversationSessionAsyncWithoutListener = function _createConversationSessionAsyncWithoutListener(conversationName, userName, accessToken, clientCreateConversationSessionHandlerParam) {
  ChatManagerInstance.createConversationSessionAsyncWithoutListener(conversationName, userName, accessToken, function (conversationSessionParam, error) {
    createConversationSessionHandler(conversationSessionParam, error, clientCreateConversationSessionHandlerParam);
  });
};

var ChatManager = {
  init: _init,
  createGlobalPresenceSession: _createGlobalPresenceSession,
  createSession: _createSession,
  createSessionAsync: _createSessionAsync,
  createConversationSession: _createConversationSession,
  checkRoomOnline: _checkRoomOnline,
  createConversationSessionAsyncWithoutListener: _createConversationSessionAsyncWithoutListener
};
var ThreadManager = {
  init: _threadInit,
  getUserDetails: _getUserDetails,
  loadAroundMessages: _loadAroundMessages,
  updateLastReadTimestamp: _threadUpdateLastReadTimestamp,
  toggleDisabledThread: _toggleDisabledThread
};
export { ChatManager, ThreadManager };